import VueApollo from "vue-apollo";
import ApolloClient from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";

const httpLink = createHttpLink({
  uri: "https://graphql.statis.nz/v1/graphql"
});

const apolloCache = new InMemoryCache();

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: apolloCache
});

export default new VueApollo({
  defaultClient: apolloClient
});



// WEBPACK FOOTER //
// ./src/services/apollo_provider.js